"use client"

import type React from "react"

/**
 * Skip Link Component
 * Allows keyboard users to skip navigation and jump to main content
 */

import { forwardRef } from "react"
import { cn } from "@/lib/utils"

interface SkipLinkProps {
  targetId: string
  children?: React.ReactNode
}

const SkipLink = forwardRef<HTMLAnchorElement, SkipLinkProps>(({ targetId, children }, ref) => {
  return (
    <a
      ref={ref}
      href={`#${targetId}`}
      className={cn(
        "sr-only",
        "focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50",
        "focus:px-4 focus:py-2",
        "focus:bg-primary focus:text-foreground",
        "focus:rounded-lg focus:shadow-lg",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        "transition-all",
      )}
    >
      {children || "Skip to main content"}
    </a>
  )
})

SkipLink.displayName = "SkipLink"

export { SkipLink }
